<div class="GlobalTrends-comingSoon">
  <div class="Wrap">
    <div class="Content">
      <div class="row">
        <div class="col-md-4">
          <img class="Simulation" src="assets/images/global-trends-simulation.png" alt="">
        </div>
        <div class="col-md-8">
          <div class="Text">
            <!-- <h3>Global Trends is coming soon</h3>
            <p>This section is under construction, thank you for your patience.</p>
            <p>Don’t hesitate to contact us if you have any questions.</p> -->
            <h3>Cullen International's new Global Trends is coming soon…</h3>
            <p>A strategic, global perspective on new frontiers in technology and their impact on regulation and policy.</p>
            <ul class="List">
              <li>As telecoms, media, the digital economy and world politics converge, it's essential for organisations to have a <b>global perspective</b> on the wide-ranging trends shaping the future of the communications sector.</li>
              <li>Our Global Tech Trends service helps leaders understand this bigger picture and set <b>strategic direction</b> for their organisation.</li>
              <li>It provides a unique, high-level view of the latest developments and their implications for decision makers across industry, government and regulation.</li>
            </ul>
            <!-- <img src="assets/images/gt-banner.jpg" alt=""> -->
            <h3>Key trends:</h3>
            <ul class="List">
              <li><b>Platforms, digital services and content:</b> Understand the complex and shifting roles of online platforms and services in debates around global economics, trade and regulation.</li>
              <li><b>Connectivity:</b> Stay on top of the latest developments in 5G, mobile and full-fibre coverage worldwide, as well as the wider relationship between global tech trends and internet connectivity.</li>
              <li><b>Data economy:</b> Follow the debate around privacy, cybersecurity, cloud and AI, and understand how new developments impact the global data economy.</li>
            </ul>
            <h3>For more information:</h3>
            <div class="Buttons">
              <a href="https://www.cullen-international.com/dam/jcr:feb78caf-a937-4d4f-9ee6-7d2b3b3cebff/Cullen-International-Global-Trends-service-brochure-2020-trifold.pdf" class="Button Button--download">Download the brochure</a>
              <p class="Or">or</p>
              <a href="https://pages.cullen-international.com/GT" class="Button Button--blue Button--contact" target="secondaryTab">Contact us</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
